import { useAzureInstallationsStatusQuery } from 'network/queries/useAzureInstallationsStatusQuery';
import { InstallationStatusMessage, Step } from 'shared/InstallationDialog';
import { spawn } from 'utils/translations';

export const CheckConnection = () => {
  const spawnStep = spawn('dialogs.azure-installation.steps.check-connection');

  useAzureInstallationsStatusQuery({ enabled: true });

  return (
    <Step title={spawnStep('title')} description={spawnStep('description')}>
      <div className="flex flex-col gap-4">
        <InstallationStatusMessage
          status="success"
          message={spawnStep('success-message')}
        />
      </div>
    </Step>
  );
};
